export function clearUrlState(): void {
  const url = window.location.href;
  const hashIndex = url.indexOf('#state=');

  if (hashIndex !== -1) {
    const newUrl = url.slice(0, hashIndex);
    window.history.replaceState(null, '', newUrl);
  }
}

export function trailingSlash(path: string): string {
  return path.endsWith('/') ? path : `${path}/`;
}
